/**
 * Internal dependencies
 */
import vd from 'lib/vd';
import setInProgress from './set-in-progress';

export default (file) => (dispatch) => {
	return vd
		.importOperation()
		.post([['file', file]])
		.then((operation) => {
			dispatch(setInProgress(operation));
			return operation;
		});
};
